var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import DetailsActionTypes from "./DetailsActionTypes.js";
const defaultSubState = {
  items: {}
};
const updateStatusData = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    items: actionResult.payload
  });
};
const ExperimentDetailsReducer = (state = defaultSubState, actionResult) => {
  switch (actionResult.type) {
    case DetailsActionTypes.UPDATE_STATUS_DATA:
      return updateStatusData(state, actionResult);
    default:
      return state;
  }
};
export {
  ExperimentDetailsReducer,
  ExperimentDetailsReducer as default
};
//# sourceMappingURL=ExperimentDetailsReducer.js.map
